<template>
	<div class="count-down">
		<span>{{hours}}</span>
		<div>
			:
		</div> <span>{{minutes}}</span>
		<div>
			:
		</div><span>{{seconds}}</span>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				hours: '00',
				minutes: '00',
				seconds: '00',
				pageTimer: {}
			}
		},
		props: {
			endTime: {
				type: String,
				default: '0'
			},
		},
		mounted() {
			this.countdowm(this.endTime);
		},
		watch: {
			endTime(curVal, oldVal) {
				if (this.pageTimer) { //清除所有的定时器，防止传过来的值变化出现闪烁的问题
					for (let each in this.pageTimer) {
						clearInterval(this.pageTimer[each]);
					}
				}
				this.countdowm(curVal, oldVal);
			}
		},
		methods: {
			countdowm(timestamp, oldtime) {
				let self = this;
				this.pageTimer["timer1"] = setInterval(function() {
					let nowTime = new Date();
					let endTime = new Date(timestamp * 1000);
					let t = endTime.getTime() - nowTime.getTime();
					if (t > 0) {
						let hour = Math.floor(t / 3600000);
						let min = Math.floor((t / 60000) % 60);
						let sec = Math.floor((t / 1000) % 60);
						hour = hour < 10 ? "0" + hour : hour;
						min = min < 10 ? "0" + min : min;
						sec = sec < 10 ? "0" + sec : sec;
						self.hours = hour;
						self.minutes = min;
						self.seconds = sec;
						let millSeconds = 9;
						self.pageTimer["timer2"] = setInterval(function() {
							if (millSeconds < 0) {
								millSeconds = 9
							}
						}, 100);
					} else {
						clearInterval(self.pageTimer["timer1"]);
						self.hours = '00';
						self.minutes = '00';
						self.seconds = '00';
						self.$emit('callback');
					}
				}, 1000);
			},
		}
	}
</script>
<style lang="scss">
	.count-down {
		display: inline-flex;
		align-items: center;

		span {
			height: 34px;
			line-height: 34px;
			width: 34px;
			background-color: #FF3E3B;
			font-size: 20px;
			color: #fff;
			text-align: center;
			border-radius: 6px;
		}

		div {
			font-size: 24px;
			color: #FF3E3C;
			padding: 4px;
		}

	}
</style>